var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boton",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.abrirInfo($event)}}},[_c('img',{attrs:{"src":require("@/assets/img/info.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }